
export default (errorValue) => {
  return `${errorValue[0]}`
}



// WEBPACK FOOTER //
// ./src/common/error.filter.js